import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-three-dual",
  templateUrl: "./axle-three-dual.component.html",
  styleUrls: ["./axle-three-dual.component.scss"],
})
export class AxleThreeDualComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorThreeIntLeftSelect: any = [];
  public sensorThreeIntRightSelect: any = [];

  public sensorThreeExtLeftSelect: any = [];
  public sensorThreeExtRightSelect: any = [];

  public sensorThreeIntRightCombo: any = [];
  public sensorThreeIntLeftCombo: any = [];

  public sensorThreeExtRightCombo: any = [];
  public sensorThreeExtLeftCombo: any = [];

  public axisThreeDoubleLeftIntForm: FormGroup;
  public axisThreeDoubleLeftExtForm: FormGroup;
  public axisThreeDoubleRightIntForm: FormGroup;
  public axisThreeDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorThreeIntRightCombo = [];
      this.sensorThreeIntLeftCombo = [];
      this.sensorThreeExtRightCombo = [];
      this.sensorThreeExtLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorThreeIntRightCombo.push(element);
          this.sensorThreeIntLeftCombo.push(element);
          this.sensorThreeExtRightCombo.push(element);
          this.sensorThreeExtLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });
    this.axisThreeDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisThreeDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisThreeDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisThreeDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorThreeExtRightCombo.push(element);
        this.sensorThreeExtLeftCombo.push(element);
        this.sensorThreeIntRightCombo.push(element);
        this.sensorThreeIntLeftCombo.push(element);
      });
    }

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisThreeDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 3 ESQ INT"
      );
      this.axisThreeDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 3 ESQ EXT"
      );

      this.axisThreeDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 3 DIR INT"
      );
      this.axisThreeDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 3 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo3DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          8
        );
        const eixo3EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          7
        );
        const eixo3DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          24
        );
        const eixo3EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          24
        );

        // EIXO 3 DIREITO EXTERNO
        if (eixo3DireitoExt != null) {
          this.axisThreeDoubleRightExtForm.controls["id"].setValue(
            eixo3DireitoExt.id
          );

          if (eixo3DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorThreeExtRightCombo, eixo3DireitoExt.sensor);
            this.sensorThreeExtRightSelect = eixo3DireitoExt.sensor.id;
          }

          if (eixo3DireitoExt.pneu != null) {
            this.axisThreeDoubleRightExtForm.controls["pneu"].setValue(
              eixo3DireitoExt.pneu.numeroFogo
            );
          }

          this.axisThreeDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo3DireitoExt.nrPressaoMinima
          );

          this.axisThreeDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo3DireitoExt.nrPressaoMaxima
          );

          this.axisThreeDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo3DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 3 ESQUERDO EXTERNO
        if (eixo3EsquerdoExt != null) {
          this.axisThreeDoubleLeftExtForm.controls["id"].setValue(
            eixo3EsquerdoExt.id
          );

          if (eixo3EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorThreeExtLeftCombo, eixo3EsquerdoExt.sensor);
            this.sensorThreeExtLeftSelect = eixo3EsquerdoExt.sensor.id;
          }

          if (eixo3EsquerdoExt.pneu != null) {
            this.axisThreeDoubleLeftExtForm.controls["pneu"].setValue(
              eixo3EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisThreeDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo3EsquerdoExt.nrPressaoMinima
          );

          this.axisThreeDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo3EsquerdoExt.nrPressaoMaxima
          );

          this.axisThreeDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo3EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 3 DIREITO INTERNO
        if (eixo3DireitoInt != null) {
          this.axisThreeDoubleRightIntForm.controls["id"].setValue(
            eixo3DireitoInt.id
          );

          if (eixo3DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorThreeIntRightCombo, eixo3DireitoInt.sensor);
            this.sensorThreeIntRightSelect = eixo3DireitoInt.sensor.id;
          }

          if (eixo3DireitoInt.pneu != null) {
            this.axisThreeDoubleRightIntForm.controls["pneu"].setValue(
              eixo3DireitoInt.pneu.numeroFogo
            );
          }

          this.axisThreeDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo3DireitoInt.nrPressaoMinima
          );

          this.axisThreeDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo3DireitoInt.nrPressaoMaxima
          );

          this.axisThreeDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo3DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 3 ESQUERDO INTERNO
        if (eixo3EsquerdoInt != null) {
          this.axisThreeDoubleLeftIntForm.controls["id"].setValue(
            eixo3EsquerdoInt.id
          );

          if (eixo3EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorThreeIntLeftCombo, eixo3EsquerdoInt.sensor);
            this.sensorThreeIntLeftSelect = eixo3EsquerdoInt.sensor.id;
          }

          if (eixo3EsquerdoInt.pneu != null) {
            this.axisThreeDoubleLeftIntForm.controls["pneu"].setValue(
              eixo3EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisThreeDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo3EsquerdoInt.nrPressaoMinima
          );

          this.axisThreeDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo3EsquerdoInt.nrPressaoMaxima
          );

          this.axisThreeDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo3EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var estepeArray: any = [];
      var posicoesPneusList: any = [];

      estepeArray.push(this.axisThreeDoubleRightExtForm.value);
      estepeArray.push(this.axisThreeDoubleRightIntForm.value);
      estepeArray.push(this.axisThreeDoubleLeftExtForm.value);
      estepeArray.push(this.axisThreeDoubleLeftIntForm.value);

      if (estepeArray.length > 0) {
        estepeArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisThreeDoubleRightExtForm.get("cdSensor").setValue("");
      this.axisThreeDoubleRightExtForm.get("id").setValue("");
      this.axisThreeDoubleRightIntForm.get("cdSensor").setValue("");
      this.axisThreeDoubleRightIntForm.get("id").setValue("");
      this.axisThreeDoubleLeftExtForm.get("cdSensor").setValue("");
      this.axisThreeDoubleLeftExtForm.get("id").setValue("");
      this.axisThreeDoubleLeftIntForm.get("cdSensor").setValue("");
      this.axisThreeDoubleLeftIntForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var estepeArray: any = [];

      estepeArray.push(this.axisThreeDoubleRightExtForm.value);
      estepeArray.push(this.axisThreeDoubleRightIntForm.value);
      estepeArray.push(this.axisThreeDoubleLeftExtForm.value);
      estepeArray.push(this.axisThreeDoubleLeftIntForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(estepeArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (estepeArray.length > 0 && this.verificarDuplicados(estepeArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    estepeArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 3 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 3 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
